import { BaseDto } from './base.dto';
import { BundleMenuCategoryItemDto } from './bundleMenuCategoryItem.dto';

export class BundleMenuCategoryDto extends BaseDto {
  name?: string;
  menuCategoryItems?: BundleMenuCategoryItemDto[];
  sequence?: number;
}
